import { getConfig } from './configs/index.js';
import path from 'path';
export const getPagesPaths = (structureType) => getConfig(structureType).pages.folders;
export const getPageFilesPaths = (structureType, folderPath) => {
    const { pages } = getConfig(structureType);
    const { structure } = pages;
    return {
        code: path.join(folderPath, structure.code),
        document: {
            structure: path.join(folderPath, structure.document.structure),
            style: path.join(folderPath, structure.document.style),
            data: path.join(folderPath, structure.document.data)
        }
    };
};
export const getPageFilesNames = (structureType, pageStructureType) => {
    const { pages } = getConfig(structureType);
    const { structure } = pages;
    if (pageStructureType === 'document') {
        return new Set([
            structure[pageStructureType].structure,
            structure[pageStructureType].data,
            structure[pageStructureType].style
        ]);
    }
    return new Set([structure[pageStructureType]]);
};
